import React from 'react'
import { TextField } from '@material-ui/core'

const DateFilter = ({ filterList, onChange, index, column, id, label }) => {
  return (
    <TextField
      fullWidth
      id={id}
      label={label}
      type="date"
      InputLabelProps={{
        shrink: true
      }}
      value={filterList[index][0] || ''}
      onChange={event => {
        filterList[index][0] = event.target.value
        onChange(filterList[index], index, column)
      }}
    />

  )
}

export default DateFilter